module.exports = (__webpack_public_path__ || '') + "static/images/tv-banner-min-1a2773e93f10aff221d6835820c1bc2a.jpg";